<template>
  <BaseExportContact
    :showSelectBuilding="false"
    postFixer="worker-info"
  >
    <HKLForm
      slot="addtional-content"
      ref="formRef"
      class="export-worker-search"
    >
      <div class="issue-date-range">
        <label class="emphasis ad-search-condition-label">
          {{ $t('project.building') }}
        </label>
        <HKLMultiSelect
          v-model="selectedBuildings"
          class="check-valid building-option"
          :required="true"
          :showTip="false"
          :options="buildingOptions"
        />
      </div>
      <div class="issue-date-range">
        <label class="emphasis ad-search-condition-label">
          {{ $t('workPermit.duration') }}
        </label>
        <HKLDateRange
          v-model="duration"
          class="check-valid"
          :required="true"
          :canPutTotop="false"
          :placeholders="[$t('dateFrom'), $t('dateTo')]"
          :displayRange="displayRange"
        />
      </div>
    </HKLForm>
  </BaseExportContact>
</template>

<script>
import { computed, ref, unref } from 'vue-demi'
import moment from 'moment'
import lodash from 'lodash'
import BaseExportContact from '@/pages/ccd/BaseExportContact'
import HKLDateRange from '@/controls/Date/HKLDateRange'
import HKLMultiSelect from '@/controls/Select/HKLMultiSelect.vue'
import { useStoreGetters } from '@/store/index'
import HKLForm from '@/controls/Form/HKLForm.vue'
import { useRefForm } from '@/controls/Form/hook'
import { exportWorker } from '../../api/workPermit/request'

export default {
  components: {
    BaseExportContact,
    HKLDateRange,
    HKLMultiSelect,
    HKLForm,
  },
  setup () {
    const { currentUserBuildings } = useStoreGetters('user', ['currentUserBuildings'])
    const { form: formRef, validate: formValidate } = useRefForm()

    const selectedBuildings = ref([])
    const duration = ref([])
    const buildingRequired = ref(false)
    const durationRequired = ref(false)

    const displayRange = computed(() => {
      const startFrom = unref(duration)[1] ? moment(unref(duration)[1]).subtract(31, 'days').toDate() : null
      const endTo = unref(duration)[0] ? moment(unref(duration)[0]).add(30, 'days').toDate() : null
      const startDateRange = { to: unref(duration)[1] || null, from: startFrom }
      const endDateRange = { to: endTo, from: unref(duration)[0] || null }
      return [startDateRange, endDateRange]
    })

    const buildingOptions = computed(() => {
      const result = unref(currentUserBuildings)
        .map(building => ({name: building.code, value: building.id}))
      return lodash.uniqBy(result, 'value')
    })
    const exportData = async () => {
      if (!formValidate()) {
        return
      }
      await exportWorker({ buildingIds: unref(selectedBuildings), from: unref(duration)[0], to: unref(duration)[1] })
    }
    const exportBtn = computed(() => {
      return {
        actionTitle: 'export',
        func: unref(exportData),
      }
    })
    return {
      exportBtn,
      selectedBuildings,
      buildingOptions,
      duration,
      durationRequired,
      buildingRequired,
      formRef,
      displayRange,
    }
  },
}
</script>

<style lang="scss" scoped>
.export-worker-search {
  display: flex;
  .building-option {
    width: 240px;
    margin-right: 50px;
    ::v-deep .ant-select-selection {
      min-height: 38px;
      .ant-select-selection__rendered {
      min-height: 38px;
      }
    }
  }
}
</style>
